<template>
    <div class="cgs-app-process-form">
        <div class="cgs-app-myprocess-header">
            <van-nav-bar :border="true">
                <template #left>
                    <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
                </template>
                <template #right>
                    <span class="iconfont cgsIcon-gongzuoliuchengtu" @click="showHistory"></span>
                </template>
            </van-nav-bar>
        </div>
        <div class="vform-container">
            <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData"
                class="vFormContent"></v-form-render>
        </div>
        <div class="approve-tool-container" v-if="detail.approved === null">
            <van-button round icon="success" type="primary" size="small" style="width: 80%"
                @click="write(true)">{{btnName.approveBtn}}
            </van-button>
        </div>
        <van-popup v-model="historyVisible" position="right" :style="{ height: '100%', width: '80%' }">
            <van-steps direction="vertical" :active="history.length - 1">
                <van-step v-for="item in history" :key="item.time">
                    <template #active-icon>
                        <van-icon name="clock" size="25" color="#07c160" style="background: #fff"/>
                    </template>
                    <template #finish-icon>
                        <van-icon name="checked" size="25" color="#51acea" style="background: #fff"/>
                    </template>
                    <template #inactive-icon>
                        <div class="steps-finish-icon">{{index+1}}</div>
                    </template>
                    <h3 style="margin-top:0px">{{ item.name }}</h3>
                    <div v-if="item.stepType === 'ROW_SAVED_OR_UPDATED'" class="history-card">
                        <div>
                            <span class="iconfont cgsIcon-wode-F" style="margin-right: 5px"></span>
                            <span>{{ item.user }}</span>
                        </div>
                        <div class="history-card-time">{{ `于 ${item.time} 发起流程` }}</div>
                        <div class="history-card-name">{{ item.name }}</div>
                    </div>
                    <div v-else-if="item.stepType == 'SEND_NOTICE'" class="history-card" v-html="item.data.msg"></div>
                    <div v-else v-for="(_item, index) in item.data.result" :key="index" class="history-card">
                        <div>
                            <span class="iconfont cgsIcon-wode-F" style="margin-right: 5px"></span>
                            <span>{{ _item.user }}</span>
                        </div>
                        <div>
                            <div v-if="item.stepType == 'FILL_IN'">
                                <span v-if="_item.approved == true" style="color:green">已通过</span>
                                <span v-else-if="_item.approved == false" style="color:red">已否决</span>
                                <span v-else style="color:#E6A23C">待填写</span>
                            </div>
                        </div>
                        <!-- <div>
                            <div style="color:#a3a3a3" v-if="_item.approveComments != ''">
                                <span>备注：</span>
                                <span>{{_item.approveComments}}</span>
                            </div>
                        </div> -->
                    </div>
                </van-step>
            </van-steps>
        </van-popup>
    </div>
</template>

<script>
    import {
        NavBar,
        Button,
        Popup,
        Steps,
        Step,
        Icon,
        Field
    } from "vant";
    import {
        getProcessDetail,
        getWorksheetInfo,
        getProcessHistory,
        updateProcess,
        updateRow
    } from '@/api/myProcess'
    import {
        getRow
    } from "@/api/application"

    export default {
        components: {
            vanNavBar: NavBar,
            vanButton: Button,
            vanPopup: Popup,
            vanSteps: Steps,
            vanStep: Step,
            vanIcon: Icon,
            vanField: Field,
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                historyVisible: false,
                detail: {},
                worksheetInfo: {},
                formJson: {},
                formData: {},
                optionData: {},
                history: [],
                userMap: {},
                rowData: {},
                approveComments: ''
            }
        },
        computed: {
            worksheetId: {
                get() {
                    let _id = ''
                    if (this.detail?.approveObject?.row?.worksheetId) {
                        _id = this.detail.approveObject.row.worksheetId
                    }
                    return _id
                },
                set() {}
            },
            rowId: {
                get() {
                    let _id = ''
                    if (this.detail?.approveObject?.rowId) {
                        _id = this.detail.approveObject.rowId
                    }
                    return _id
                },
                set() {}
            },
            autoInstanceId: {
                get() {
                    let _id = ''
                    if (this.detail?.autoInstanceId) {
                        _id = this.detail.autoInstanceId
                    }
                    return _id
                },
                set() {}
            },
            autoNodeId: {
                get() {
                    let _id = ''
                    if (this.detail?.autoNodeId) {
                        _id = this.detail.autoNodeId
                    }
                    return _id
                },
                set() {}
            },
            worksheetConfig: {
                get() {
                    let _config = {}
                    if (this.worksheetInfo?.config) {
                        _config = JSON.parse(this.worksheetInfo.config)
                    }
                    return _config
                },
                set() {}
            },
            btnName: {
                get() {
                    let _btnName = {
                        approveBtn: '通过',
                        rejectBtn: '否决'
                    }
                    if(this.detail?.btnName){
                        _btnName = this.detail.btnName
                    }
                    return _btnName
                },
                set() {}
            }
        },
        async created() {
            try {
                let detailResult = await getProcessDetail(this.id)
                if (detailResult.code === 200) {
                    this.detail = detailResult.data
                    let worksheetResult = await getWorksheetInfo(this.worksheetId)
                    let rowResult = await getRow(this.worksheetId, this.rowId)
                    if (worksheetResult.code === 200) {
                        this.worksheetInfo = worksheetResult.data
                    }
                    if (rowResult.code === 200) {
                        this.rowData = rowResult.data
                    }
                    let params = {
                        nodeId: this.autoNodeId,
                        autoInstanceId: this.autoInstanceId
                    }
                    let historyResult = await getProcessHistory(params)
                    if (historyResult.code === 200) {
                        this.history = historyResult.data
                    }
                    let fieldSettings = detailResult.data.fieldSettings
                    for (let i = 0; i < this.worksheetConfig.widgetList.length; i++) {
                        for (let k in fieldSettings) {
                            if (k === this.worksheetConfig.widgetList[i].id) {
                                if (fieldSettings[k].read === true) {
                                this.worksheetConfig.widgetList[i].options.hidden = false;
                                } else {
                                this.worksheetConfig.widgetList[i].options.hidden = true;
                                }
                                if (fieldSettings[k].write === true) {
                                this.worksheetConfig.widgetList[i].options.disabled = false;
                                } else {
                                this.worksheetConfig.widgetList[i].options.disabled = true;
                                }
                                if (fieldSettings[k].required === true) {
                                this.worksheetConfig.widgetList[i].options.required = true;
                                } else {
                                this.worksheetConfig.widgetList[i].options.required = false;
                                }
                            }
                        }
                    }
                    this.$nextTick(() => {
                        this.$refs.vFormRef.setFormJson(this.worksheetConfig);
                        this.$refs.vFormRef.setFormData(this.rowData);
                    })
                    if(this.detail.approved !== null){
                        setTimeout(() => {
                            this.$refs.vFormRef.disableForm()
                        }, 100)
                    }
                }
            } catch (err) {}

        },
        methods: {
            goBack() {
                this.$router.go(-1)
            },
            showHistory() {
                this.historyVisible = true
            },
            async write(bool) {
                let data = this.$refs.vFormRef.formDataModel
                let params = {
                    approved: bool,
                    id: this.id
                }
                let updateData = {
                    worksheetId: this.worksheetId,
                    rowId: this.rowId,
                    data: data
                }
                try {
                    let formData = await this.$refs.vFormRef.getFormData();
                    let result1 = await updateRow(updateData)
                    if (result1.code === 200) {
                        let result = await updateProcess(params)
                        if (result.code === 200) {
                            this.goBack()
                        }
                    }
                } catch (err) {}
            }
        }

    }
</script>

<style scoped>
    .cgs-app-process-form {
        display: flex;
        flex-direction: column;
    }

    .vform-container {
        flex: 1;
        overflow-y: auto;
    }

    .approve-tool-container {
        /* height: 30px; */
        text-align: center;
        padding: 10px 
    }

    .history-card {
        padding: 10px;
        background: #f8f8f8;
        border-radius: 2px;
    }

    .history-card-time {
        color: #969799;
    }

    .history-card-name {
        color: #969799;
    }

    .approve-tool-container-popup {
        text-align: center;
        display: flex;
        height: 40px;
        line-height: 40px;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
    .steps-finish-icon{
        border:3px solid #c1c4c7;
        border-radius:50%;
        width: 20px;
        height:20px;
        background:#f6f5f5;
        line-height: 20px;
        text-align: center;
        font-size: 10px;
        color: #c1c4c7;
    }
</style>